export enum LqaUserAccessType {
    LQAAdmin = 'LQAAdmin',
    LQABasic = 'LQABasic',
}
